// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { PFixFieldSet } from '../Fields/FieldsImport.js'
import { FieldsFactory } from '../Factory/FieldsFactory.js'

export var MarginPriceBasedMultipleLeverage = function (pfixFieldSet)    
{
    PFixFieldSet.call(this, FieldsFactory.MARGIN_PRICE_BASED_MULTIPLE_LEVERAGE, null, pfixFieldSet)
}
MarginPriceBasedMultipleLeverage.prototype = Object.create(PFixFieldSet.prototype)

MarginPriceBasedMultipleLeverage.prototype.getLeverage = function ()
{
    return this.GetValue(FieldsFactory.FIELD_LEVERAGE_SHORT)
}

MarginPriceBasedMultipleLeverage.getLeverages = function (groups)
{
    let result = []

    if (groups)
        for (let i = 0; i < groups.length; i++)
        {
            let group = new MarginPriceBasedMultipleLeverage(groups[i])
            if (group)
                result.push(group.getLeverage())
        }

    return result.sort((a, b) => a - b)     // leverage сортируем по возрастанию #113809
}
